<template>
  <div>
    <div class="video_channel">
      <div class="vc_concent">
        <div class="vc_item" v-for="item in channelList" :key="item.at_id">
          <a
            :href="
              item.at_name == '推荐'
                ? '/marvel-list?id=' + item.at_id
                : '/list-page?id=' + item.at_id
            "
            target="_blank"
          >
            {{ item.at_name }}
          </a>
        </div>
      </div>
    </div>
    <div class="video_details">
      <!--      <video-->
      <!--        id="video"-->
      <!--        width="900"-->
      <!--        height="510"-->
      <!--        controls-->
      <!--        autoplay-->
      <!--        src="https://bj.bcebos.com/kpy-organizations/U14176668/videos/2021102814122787062456749512.mp4"-->
      <!--        poster="https://bj.bcebos.com/kpy-organizations/U14176668/gimages/2021102814124439534991403861.jpg"-->
      <!--      ></video>-->
      <div class="v_player">
        <video-player
          v-if="playerOptions.sources[0].src"
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        ></video-player>
        <div class="error_page" v-if="!playerOptions.sources[0].src">
          {{ loadMessage }}
        </div>
      </div>
      <div class="video_album" v-show="isAlbumDisplay">
        <div class="album_bar">
          <span class="album_item">选集</span>
          <span class="cancel" @click="disPlayAlbum">取消</span>
        </div>
        <ul class="album_num">
          <li
            v-for="(item, index) in albumList"
            :key="item"
            :class="item == videoId ? 'active' : ''"
          >
            <a
              :href="
                '/play-page?classify=3&id=' + currentId + '&video_id=' + item
              "
              >{{ index + 1 }}</a
            >
            <!--            <p class="item_idx">{{ index+1 }}</p>-->
          </li>
        </ul>
      </div>

      <div class="vd_right">
        <div v-if="isAlbum" class="vd_header">
          <div class="vdh_author">
            <img :src="image" />
          </div>
          <div class="vdh_title">
            <p>
              {{ name }}
            </p>
            <el-button type="text" @click="dialogVisible = true"
              >关注</el-button
            >
            <!--            <button>关注</button>-->
          </div>
        </div>
        <div class="vd_title">
          <p>
            {{ title }}
            <button v-if="isOriginal">原创</button>
          </p>
        </div>
        <div class="vd_text" v-html="description"></div>
        <div class="vd_play_comments">
          <div class="vdc_play">{{ hitCount }}次播放</div>
          <div class="vdc_comments">
            {{ reviewCount ? reviewCount : 0 }}条评论
          </div>
        </div>
        <div class="vd_release">发布于{{ publishDate }}</div>
        <div class="vd_copyright">版权归原作者所有，如有侵权，请联系我们</div>
        <div class="share_info">
          <div class="share_sub">分享到：</div>
          <div
            class="social-share"
            data-sites="wechat, weibo, qq, qzone, douban"
          ></div>
          <!--          <share :config="config"></share>-->
        </div>
      </div>
      <div v-if="hasRecommend" class="recommend">
        <div class="title">相关推荐</div>
        <ul class="content">
          <li v-for="item in recommendList" :key="item.id">
            <a
              :href="'/play-page?id=' + item.id + '&classify=' + item.classify"
              target="_blank"
            >
              <div class="cul_img">
                <img :src="item.img_url" alt="" />
                <div class="time">
                  <span class="v_pub">{{ item.publish_date }}</span>
                  <span class="v_dur"> {{ item.video_duration }}</span>

                  <!--                <div class="fr">{{item.video_duration}}</div>-->
                </div>
              </div>
              <div class="cul_title1">
                {{ item.title }}
              </div>
              <!--              <div v-show="item.article_source" class="cul_title2">-->
              <!--                {{ item.article_source }}-->
              <!--              </div>-->
            </a>
          </li>
        </ul>
      </div>
      <div class="vd_cmt">
        <div class="comment">
          <div v-if="commentList.length > 0" class="title">评论</div>
          <li class="item" v-for="item in commentList" :key="item.id">
            <div class="item_label">
              <div class="portrait">
                <div class="p_img">
                  <img :src="item.member.avatar" alt="" />
                </div>
              </div>
              <div class="commentator">{{ item.member.nickname }}</div>
              <div class="grade">
                {{ item.member.from_grade ? item.member.from_grade : "游客" }}
              </div>
            </div>
            <div class="item_text">{{ item.content }}</div>
            <div class="item_date">{{ item.push_time }}</div>
          </li>
        </div>
        <div v-if="hasComment" class="act_footer">
          请
          <!--          <button class="btn" data-toggle="modal" data-target="#myModal">-->
          <!--            打开-->
          <!--          </button>-->
          <el-button type="text" @click="dialogVisible = true">打开</el-button>
          科普中国APP发表评论或查看更多评论
        </div>
      </div>
    </div>
    <download-dialog :visible.sync="dialogVisible"></download-dialog>
  </div>
</template>
<script>
import downloadDialog from "./component/DownloadDialog.vue";
import {
  getChannelList,
  getVideoDetail,
  getCommentList,
  getHaoVideoDetail,
  getAlbumVideoDetail,
} from "@/api";
import videojs from "video.js";

// import shareJs from "social-share.js"
export default {
  components: { downloadDialog },
  data() {
    return {
      dialogVisible: false,
      isAlbumDisplay: false,
      hasComment: false,
      hasRecommend: false,
      channelList: [],
      isAlbum: false,
      currentId: "",
      videoId: "",
      isOriginal: false,
      loadMessage: "Loading.....",
      title: "",
      name: "",
      image: "",
      hitCount: "",
      reviewCount: "",
      publishDate: "",
      description: "",
      recommendList: [],
      commentList: [],
      albumList: [],
      playerOptions: {
        playbackRates: [0.5, 1, 1.5, 2],
        autoplay: true,
        poster: "",
        // fluid: true,
        sources: [
          {
            type: "video/mp4",
            src: "",
          },
        ],
        height: 510,
        controlBar: {
          children: [
            "playToggle",
            "volumePanel",
            "currentTimeDisplay",
            "progressControl",
            "timeDivider",
            "durationDisplay",
            "fullscreenToggle",
            "customButton",
            "playbackRateMenuButton",
            "pictureInPictureToggle",
          ],
        },
      },
      config: {
        sites: ["wechat", "weibo", "qq", "qzone", "douban"],
      },
    };
  },
  methods: {
    disPlayAlbum: function () {
      this.isAlbumDisplay = !this.isAlbumDisplay;
    },

    async initPlayPage() {
      try {
        let id = this.$route.query.id;
        let res;
        if (this.$route.query.classify == 3) {
          this.currentId = id;
          let videoId = this.$route.query.video_id;
          if (videoId) {
            res = await getAlbumVideoDetail({ ar_id: id, video_id: videoId });
            this.videoId = videoId;
          } else {
            res = await getAlbumVideoDetail({ ar_id: id });
            if (
              res.data.information.list &&
              res.data.information.list.length > 0
            ) {
              this.videoId = res.data.information.list[0];
            }
          }
          this.albumList = res.data.information.list;
          if (res.data.information.list.length > 0) {
            this.isAlbumDisplay = true;
            this.initAlbumButton();
          }
        } else {
          if (!isNaN(parseInt(id))) {
            this.isAlbum = true;
            res = await getHaoVideoDetail({
              ar_id: id,
            });
            this.name = res.data.information.website.name;
            this.image = res.data.information.website.image;
            // this.reviewCount = res.data.information.review_count;
            this.isOriginal = res.data.information.original == 3;
          } else {
            res = await getVideoDetail({
              ar_id: id,
            });
            // this.name = res.data.information.article_compose;
            // this.image = res.data.information.tts_image;
            // this.reviewCount = res.data.information.review_count;
          }
        }
        this.title = res.data.information.title;
        this.hitCount = res.data.information.hits;
        this.publishDate = res.data.information.publish_date;
        this.description = res.data.information.description;
        this.playerOptions.poster = res.data.information.img_url;
        this.playerOptions.sources[0].src = res.data.information.movie_url;
        this.recommendList = res.data.recommend_list;
        if (!res.data.information.movie_url) {
          this.playerOptions.sources[0].src = "badresquest";
        }
        if (res.data.recommend_list && res.data.recommend_list.length > 0) {
          this.hasRecommend = true;
        }
        this.$nextTick(() => this.getCommentList());
      } catch (e) {
        console.log(e);
      }
    },

    async initChannelList() {
      try {
        let { data } = await getChannelList();
        this.channelList = data;
      } catch (e) {
        console.log(e);
      }
    },

    async getCommentList() {
      let id = this.$route.query.id;
      let type = 1;
      if (!isNaN(parseInt(id))) {
        type = 3;
      }
      let classsify = this.$route.query.classify;
      if (classsify == 3) {
        let videoId = this.$route.query.video_id;
        if (videoId) {
          id = videoId;
        } else {
          id = this.albumList[0];
        }
      }
      try {
        let { data } = await getCommentList({ ar_id: id, tar_type: type });
        if (data.list.length > 3) {
          this.commentList = data.list.slice(0, 3);
        } else {
          this.commentList = data.list;
        }
        this.reviewCount = data.count;
        this.hasComment = data.list && data.list.length > 0;
      } catch (e) {
        console.log(e);
      }
    },

    initAlbumButton() {
      var VjsButton = videojs.getComponent("button");
      var customButton = videojs.extend(VjsButton, {
        constructor: function (player, options) {
          VjsButton.call(this, player, options);
          this.controlText("视频选集");
        },
        handleClick: () => {
          this.isAlbumDisplay = !this.isAlbumDisplay;
        },
        buildCSSClass: function () {
          return "vjs-album-control";
        },
      });
      videojs.registerComponent("customButton", customButton);
    },
  },
  created() {
    this.initPlayPage();
    this.initChannelList();
    // this.getCommentList();
  },
  mounted() {
    // eslint-disable-next-line no-undef
    socialShare(".social-share, .share-component");
  },
};
</script>
<style lang="scss" scoped>
ul,
ol {
  list-style: none outside none;
}

ul,
ol,
li,
dl,
dt,
dd {
  padding: 0;
  margin: 0;
}

.video_channel {
  height: 120px;
  margin-bottom: 40px;
  background: #fff;
  box-shadow: 0 4px 20px 0 rgba(74, 118, 227, 0.23);

  .vc_concent {
    display: flex;
    flex-wrap: wrap;
    padding: 24px 0 0;
    @include wrap;

    .vc_item {
      position: relative;
      width: 220px;
      margin-bottom: 10px;
      font-size: 22px;
      font-weight: 600;
      line-height: 30px;
      color: #353535;
      a {
        font-family: PingFangSC-Semibold, sans-serif;
        color: #353535;
        text-decoration: none;
      }
      a:hover {
        color: #1f91f4;
      }
    }

    .vc_item:nth-child(1)::before,
    .vc_item:nth-child(2)::before,
    .vc_item:nth-child(3)::before,
    .vc_item:nth-child(4)::before,
    .vc_item:nth-child(5)::before {
      @include channelSize;
    }

    .vc_item:nth-child(6n + 6) {
      width: 100px;
    }
  }
}

.video_details {
  position: relative;
  @include wrap;
  //video {
  //  margin-bottom: 50px;
  //  vertical-align: middle;
  //}

  .v_player {
    width: 906px;
    height: 510px;
    margin-bottom: 50px;
    vertical-align: middle;
    ::v-deep .vjs-album-control {
      order: 10;
      width: 42px;
      background: url("~@/assets/xuanji.png") no-repeat center;
    }
    .error_page {
      font-size: 20px;
      text-align: center;
      background-color: #383838;
    }
  }

  .video_album {
    position: absolute;
    top: 0;
    right: 294px;
    width: 200px;
    height: 510px;
    background: #000;
    opacity: 0.6;
    //ul{
    .album_bar {
      display: inline-block;
      width: 200px;
      height: 28px;
      margin-top: 18px;
      font-size: 14px;
      color: #fff;
      .album_item {
        float: left;
        margin-left: 18px;
      }

      .cancel {
        float: right;
        margin-right: 18px;
      }
      .cancel:hover {
        color: #7082f3;
      }
      //border: 2px solid red;
    }

    .album_num {
      width: 200px;
      height: 422px;
      margin-top: 10px;
      overflow: auto;
      //scrollbar-width: none;
      s * {
        padding: 0;
        margin: 0;
        list-style: none;
      }

      li {
        float: left;
        width: 32px;
        height: 32px;
        margin-bottom: 10px;
        margin-left: 12px;
        a {
          display: inline-block;
          width: 28px;
          height: 14px;
          padding: 9px 2px;
          font-size: 14px;
          color: #fff;
          text-align: center;
          text-decoration: none;
        }

        //border: 2px solid red;
      }
      .active {
        background-color: #619aff;
      }
      li:nth-child(4n + 1) {
        margin-left: 18px;
      }
      li:hover {
        background: #7082f3;
      }
    }
    //.album_num::-webkit-scrollbar {
    //  width: 0 !important;
    //  //-ms-overflow-style: none;
    //  //overflow: -moz-scrollbars-none;
    //}

    //}
  }

  //.album_active{
  //
  //}

  .vd_right {
    position: absolute;
    top: 0;
    right: 0;
    width: 276px;
    height: 510px;

    .vd_header {
      margin-bottom: 30px;
      @include clearfix;

      .vdh_author {
        position: relative;
        float: left;
        width: 70px;
        height: 70px;
        overflow: hidden;
        border-radius: 50%;

        img {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: auto;
          transform: translate(-50%, -50%);
        }
      }

      .vdh_title {
        float: left;
        width: 196px;
        margin-left: 10px;

        p {
          margin: 0 0 10px;
          font-size: 18px;
          font-weight: bold;
          color: #333;
        }

        button {
          width: 50px;
          height: 24px;
          padding: 0;
          font-size: 14px;
          color: #fff;
          background: #1f91f4;
          border: none;
          border-radius: 4px;
        }
      }
    }

    .vd_title {
      width: 100%;
      margin-bottom: 10px;

      p {
        font-size: 18px;
        font-weight: 600;
        color: #333;

        button {
          display: inline-block;
          width: 40px;
          height: 18px;
          font-size: 12px;
          color: #fff;
          background: #5381e8;
          border: none;
          border-radius: 4px;
        }
      }
    }

    .vd_text {
      width: 256px;
      height: 180px;
      padding: 10px;
      margin-bottom: 20px;
      overflow-x: hidden;
      overflow-y: auto;
      font-size: 14px;
      color: #666;
      ::v-deep p {
        font-size: 14px;
      }
      img {
        width: 100%;
        height: auto;
      }
    }

    /* 滚动条 */
    .vd_text::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    .vd_text::-webkit-scrollbar-thumb {
      background-color: #cbcbcb;
      border-radius: 3px;
    }

    .vd_text::-webkit-scrollbar-track {
      background-color: rgba(255, 255, 255, 0.1);
      border-radius: 3px;
    }

    .vd_play_comments {
      @include clearfix;
      @include fontSize(14px, 400, #999, 18px);

      .vdc_play {
        float: left;
      }

      .vdc_comments {
        float: right;
      }
    }

    .vd_release {
      margin: 12px 0;
      @include fontSize(14px, 400, #999, 18px);
    }

    .vd_copyright {
      @include fontSize(14px, 400, #999, 18px);
    }
    .share_info {
      margin-top: 8px;
      .share_sub {
        float: left;
        height: 26px;
        margin-top: 4px;
        vertical-align: middle;
        @include fontSize(14px, 400, #999, 18px);
      }
      ::v-deep .social-share-icon {
        width: 16px;
        height: 16px;
        font-size: 10px;
        line-height: 16px;
      }
    }
  }

  .recommend {
    .title {
      margin: 0 0 16px;
      @include fontSize(24px, bold, #333, 30px);
    }

    .content {
      @include clearfix;

      li {
        float: left;
        width: 270px;
        height: 220px;
        margin-right: 40px;
        a {
          text-decoration: none;
        }

        .cul_img {
          //position: relative;
          width: 270px;
          height: 151px;
          overflow: hidden;
          background-color: #d8d8d8;
          border-radius: 4px;

          img {
            width: 100%;
            //position: absolute;
            //top: 50%;
            //left: 50%;
            //z-index: 3;
            height: 100%;
            //transform: translate(-50%, -50%);
          }

          .time {
            width: 100%;
            height: 18px;
            //position: absolute;
            //bottom: 0;
            //left: 0;
            //z-index: 10;
            //box-sizing: border-box;
            margin-top: -20px;
            //padding: 10px 12px;
            font-size: 14px;
            font-weight: 500;
            line-height: 12px;
            color: #fff;
            //color: red;

            span {
              display: inline-block;
              width: 40%;
              height: 100%;
            }
            span:nth-child(1) {
              margin-left: 5%;
              text-align: left;
            }
            span:nth-child(2) {
              margin-left: 10%;
              text-align: right;
            }
          }
        }

        .cul_title1 {
          margin: 10px 0;
          @include fontSize(16px, 500, #333);
          @include textoverflow;
        }

        .cul_title2 {
          @include fontSize(14px, 400, #999);
        }
      }
    }
  }

  .vd_cmt {
    margin: 20px 0 60px;

    .comment {
      .title {
        position: relative;
        padding-left: 18px;
        @include fontSize(24px, 500, #333);
      }

      .title::after {
        position: absolute;
        top: 6px;
        left: 0;
        display: block;
        width: 6px;
        height: 22px;
        content: "";
        background-color: #0064c9;
      }

      .item {
        margin: 15px 0 30px;
        list-style: none;

        .item_label {
          @include clearfix;

          .portrait {
            position: relative;
            float: left;
            width: 42px;
            height: 42px;

            .p_img {
              width: 100%;
              height: 100%;
              overflow: hidden;
              border-radius: 50%;

              img {
                width: 100%;
                height: auto;
                vertical-align: middle;
              }
            }

            .p_img::after {
              position: absolute;
              right: 0;
              bottom: 0;
              display: block;
              width: 20px;
              height: 20px;
              line-height: 20px;
              color: #fff;
              text-align: center;
              content: "证";
              background-color: #fd7b43;
              border-radius: 50%;
            }
          }

          .commentator {
            float: left;
            margin-left: 16px;
            @include fontSize(18px, 500, #333, 42px);
          }

          .grade {
            position: relative;
            float: left;
            margin-left: 20px;
            @include fontSize(18px, 500, #fd7b43, 42px);
          }

          .grade::before {
            position: absolute;
            top: 19px;
            left: -10px;
            display: inline-block;
            width: 4px;
            height: 4px;
            margin-right: 4px;
            content: "";
            background-color: #fd7b43;
            border-radius: 50%;
          }
        }

        .item_text {
          margin-left: 58px;
          @include fontSize(16px, 400, #333, 22px);
        }

        .item_date {
          margin: 15px 0 0 58px;
          @include fontSize(14px, 400, #999, 20px);
        }
      }
    }

    .act_footer {
      box-sizing: border-box;
      width: 100%;
      height: 46px;
      padding-left: 20px;
      margin-top: 40px;
      line-height: 46px;
      text-align: center;
      background: #f4f4f4;
      border-radius: 23px;
      @include clearfix;

      button {
        height: 24px;
        padding: 0 8px;
        margin: 0 2px;
        color: #fff;
        background: linear-gradient(180deg, #ee275f 0%, #fc7544 100%);
        background-color: #2491ea;
        background-image: -moz-linear-gradient(
          180deg,
          #65b5fc 0%,
          #2491ea 100%
        );
        background-image: -o-linear-gradient(180deg, #65b5fc 0%, #2491ea 100%);
        background-image: -webkit-gradient(180deg, #65b5fc 0%, #2491ea 100%);
        background-image: -webkit-linear-gradient(
          180deg,
          #65b5fc 0%,
          #2491ea 100%
        );
        background-image: -ms-linear-gradient(180deg, #65b5fc 0%, #2491ea 100%);
        background-image: linear-gradient(180deg, #65b5fc 0%, #2491ea 100%);
        border: none;
        border-radius: 14px;
        outline: none;
      }
    }
  }
}
</style>
